//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import axios from 'axios';

export default {
  data () {
    return {
      faq_categories: [],
      faq: [],
      pagination: {
        'base_url'      : '',
        'current_page'  : 0,
        'per_page'      : 6,
        'total_pages'   : 1,
        'total_posts'   : 1,
      },
      category: '',
      language: 'en',
      page: 1,
      pagesBefore: [],
      pagesAfter: [],
    }
  },

  mounted: function() {
    this.getFaqCategories();
    this.getCurrentLanguage();
    this.getPageNumber();
    this.getCurrentCategory();
    this.getFaqs();

    // Get Selectpicker to function within VueJS
    const $selectpicker = $(this.$el).find('.selectpicker');

    if ($(window).width() > 991) {
      $selectpicker.selectpicker({
        style: 'bs-dropdown',
        size: 4,
        dropupAuto : false,
      });
    } else {
      $selectpicker.selectpicker({
        style: 'bs-dropdown',
        mobile : true,
      });
    }
  },

  updated() {
    $(this.$el).find('.selectpicker').selectpicker('refresh');
  },

  methods: {
    getCurrentLanguage() {
      let that = this;
      var url = window.location.href;

      // By defauly, language is already en, but if url contains /mt/, change this to mt
      if (url.indexOf('/mt/') !== -1) {
        that.language = 'mt';
      }
    },

    setCategory(id) {
      let that = this;

      that.category = id;
      this.getFaqs();
    },

    calculatePagesBefore(currentPage) {
      let that = this;
      var before = [];
      var i = 0;

      for (i = 1; i < parseInt(currentPage); i++) {
        before.push(i);
      }

      that.pagesBefore = before;
    },

    calculatePagesAfter(currentPage) {
      let that = this;
      var after = [];
      var i = 0;

      for (i = parseInt(currentPage) + 1; i <= that.pagination.total_pages; i++) {
        after.push(i);
      }

      that.pagesAfter = after;
    },

    goToFirstPage() {
      /*
       * After filtering through dropdown, there is a chance that we are on a page number which
       * no longer has posts which can be displayed on it.. 
       * (number of posts < number of pages * posts per page)
       *
       * This will result in empty canvas onb this page
       * To mitigate against, after filtering, redirect user to first page of filtered archive
       * by building a url through vue components and using vanilla window.location()
       *
       * Since we are triggering an extra page load, we need to add an extra check so that
       * if user is already on page 1, we do not needlessly redirect.
       */
      let that = this;

      if (parseInt(that.pagination.current_page) !== 1) {
        window.location.href = that.pagination.base_url + '?category=' + that.category ;
      }
    },

    getFaqs() {
      let that = this;
      var $pathname = encodeURIComponent(window.location.pathname);

      axios.get('/wp-json/wp/v2/generic-posts?cat=' + that.category + '&paged=' + that.page + '&postType=faq&taxonomy=faq_taxonomy&perPage=' + that.pagination.per_page + '&returnPath=' + $pathname + '&language=' + that.language )
      .then(function (response) {
        that.faq = response.data.posts;
        that.pagination = response.data.pagination;
      
        // Only calculate previous and following pages after we get pagination details and faq articles
        that.calculatePagesBefore(response.data.pagination.current_page);
        that.calculatePagesAfter(response.data.pagination.current_page);
      })
      .catch(function (error) {
        console.log(error);
      });

    },

    getPageNumber() {
      let that = this;

      if (jQuery('#current-page').data('page')) {
        that.page = jQuery('#current-page').data('page');
      }
    },

    getCurrentCategory() {
      let that = this;

      if (jQuery('#current-category').data('category')) {
        that.category = jQuery('#current-category').data('category');
      }
    },

    getFaqCategories() {
      let that = this;

      axios.get('/wp-json/wp/v2/faq_categories')
      .then(function (response) {
        that.faq_categories = response.data;
      })
      .catch(function (error) {
        console.log(error);
      });
    },
  },
}



// WEBPACK FOOTER //
// ./scripts/vue/faqs.vue